jQuery(document).ready(function($){
    $('.main-nav__toggle').on('click', function(e){
        e.preventDefault();

        $(this).toggleClass('main-nav__toggle--active');
        $('.main-nav__wrapper').toggleClass('main-nav__wrapper--active');
        $('html, body').toggleClass('hide-overflow');
    });
});